import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scan'
})
export class ScanPipe implements PipeTransform {
  transform(
    items: Array<any>,
    scansource : string,
   
  ): Array<any> {
    if (items && items.length) {
      return items.filter(item => {
        console.log(scansource)
        
        if (scansource !== '-' && item.source.indexOf(scansource) === -1) {
          return false;
        }
        if (scansource !== '-' && item.source === undefined) {
          return false;
        }
        if (scansource === '-' && item.source !== undefined) {
          return items;
        }

        
        return true;
      });
    } else {
      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/filter/scan.pipe.ts